<div class="layer-controls">
  <mat-slide-toggle [formControl]="activeControl">{{ mapLayer().displayName }}</mat-slide-toggle>

  <div class="icon-container">
    @if (additionIcons().download && activeControl.value) {
      <vulcan-icon class="clickable" size="20px" icon="download-simple" weight="fill"
                   (click)="emitAction($event,'download')"></vulcan-icon>
    }

    @if (additionIcons().identify && activeControl.value) {
      <vulcan-icon class="clickable"
                   [class.identifiable]="isIdentifiable()"
                   size="20px" icon="magnifying-glass" weight="regular"
                   (click)="emitAction($event,'identify')"></vulcan-icon>
    }

    @if (additionIcons().info) {
      <vulcan-icon class="clickable" size="20px" icon="info" weight="fill" role="tooltip"
                   (click)="openLayerInfoModal($event)"></vulcan-icon>
    }
  </div>

</div>

<div class="hide" [class.show]="activeControl.value">

  <ng-content select="filters"></ng-content>

  <ng-content></ng-content>

  <div class="opacity-slider">
    <mat-slider min="0" max="100" step="1" discrete [displayWith]="formatLabel">
      <input id="opacity-slider" matSliderThumb [formControl]="opacityControl">
    </mat-slider>
    <label for="opacity-slider">Opacity</label>
  </div>

</div>

